
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tech/refund-policy",
      function () {
        return require("private-next-pages/tech/refund-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tech/refund-policy"])
      });
    }
  